import { mdiCheck, mdiContentCopy } from '@mdi/js'
import Icon from '@mdi/react'
import { ActionsStrip } from 'components/ActionsStrip'
import { MouseEvent, useState } from 'react'
import styles from './ChatTextBubble.pcss'

const ICON_SIZE_SM = '16px'
const COPY_FEEDBACK_MS = 2000
const TRUNCATE_LENGTH = 500

interface ChatTextBubbleProps {
  role: 'user' | 'assistant'
  text: string
  testId?: string
}

export function ChatTextBubble({ role, text, testId }: ChatTextBubbleProps) {
  const [copied, setCopied] = useState(false)
  const [expanded, setExpanded] = useState(false)

  const onCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), COPY_FEEDBACK_MS)
    })
  }

  const isTruncatable = role === 'user' && text.length > TRUNCATE_LENGTH
  const displayText = isTruncatable && !expanded ? `${text.slice(0, TRUNCATE_LENGTH)}…` : text

  const onToggleExpanded = (e: MouseEvent) => {
    e.stopPropagation()
    setExpanded(prev => !prev)
  }

  return (
    <div
      data-testid={testId}
      data-role={role}
      data-kind="text"
      className={`${styles.message} ${styles[role]}`}
    >
      <div className={styles.bubble} onClick={onCopy}>
        {displayText}
        {isTruncatable && (
          <button type="button" className={styles['show-more']} onClick={onToggleExpanded}>
            {expanded ? 'Show less' : 'Show more'}
          </button>
        )}
      </div>
      <ActionsStrip
        className={styles['msg-actions']}
        actions={[{
          icon: <Icon path={copied ? mdiCheck : mdiContentCopy} size={ICON_SIZE_SM} />,
          tooltip: copied ? 'Copied!' : 'Copy',
          onClick: onCopy
        }]}
      />
    </div>
  )
}

export default ChatTextBubble
